module.exports = function getResource(label, vars = []) {
    let resources = {
        allPhotos: 'All Photos',
        myPhotos: 'My Photos',
        addAPhoto: 'Add a Photo'
    };
    return resources[label];
};
